import { daysAgo, type HomeStat } from "./collection_counts";

const platformQuery = (
    platform: "android" | "ios",
): HomeStat["queries"][number] => ({
    path: "devices",
    field: "platform",
    op: "==",
    value: platform,
});

const usersPlatformQuery = (
    platform: "android" | "ios",
): HomeStat["queries"][number] => ({
    path: "users",
    field: "platform",
    op: "==",
    value: platform,
});

/** Composite index gerekir: users → platform ASC + createdAt ASC */
const usersPlatform7dQuery = (
    platform: "android" | "ios",
): HomeStat["queries"][number] => ({
    path: "users",
    filters: [
        {
            field: "platform",
            op: "==",
            value: platform,
        },
        {
            field: "createdAt",
            op: ">=",
            value: () => daysAgo(7),
        },
    ],
});

/**
 * Anasayfa sayaçları — aggregation count(); koleksiyonu indirmez.
 */
export const homeStats: HomeStat[] = [
    {
        key: "users",
        label: "Kullanıcılar",
        collectionPath: "users",
        queries: [{ path: "users" }],
    },
    {
        key: "users_android",
        label: "Kullanıcılar (Android)",
        collectionPath: "users",
        filter: {
            field: "platform",
            op: "==",
            value: "android",
        },
        queries: [usersPlatformQuery("android")],
    },
    {
        key: "users_ios",
        label: "Kullanıcılar (iOS)",
        collectionPath: "users",
        filter: {
            field: "platform",
            op: "==",
            value: "ios",
        },
        queries: [usersPlatformQuery("ios")],
    },
    {
        key: "users_7d",
        label: "Yeni kayıt (7 gün)",
        collectionPath: "users",
        filter: {
            field: "createdAt",
            op: ">=",
            value: () => daysAgo(7),
        },
        queries: [{
            path: "users",
            field: "createdAt",
            op: ">=",
            value: () => daysAgo(7),
        }],
    },
    {
        key: "users_7d_android",
        label: "Yeni kayıt Android (7 gün)",
        collectionPath: "users",
        filter: [
            {
                field: "platform",
                op: "==",
                value: "android",
            },
            {
                field: "createdAt",
                op: ">=",
                value: () => daysAgo(7),
            },
        ],
        queries: [usersPlatform7dQuery("android")],
    },
    {
        key: "users_7d_ios",
        label: "Yeni kayıt iOS (7 gün)",
        collectionPath: "users",
        filter: [
            {
                field: "platform",
                op: "==",
                value: "ios",
            },
            {
                field: "createdAt",
                op: ">=",
                value: () => daysAgo(7),
            },
        ],
        queries: [usersPlatform7dQuery("ios")],
    },
    {
        key: "devices",
        label: "Cihazlar",
        collectionPath: "devices",
        queries: [{ path: "devices" }],
    },
    {
        key: "devices_android",
        label: "Cihazlar (Android)",
        collectionPath: "devices",
        filter: {
            field: "platform",
            op: "==",
            value: "android",
        },
        queries: [platformQuery("android")],
    },
    {
        key: "devices_ios",
        label: "Cihazlar (iOS)",
        collectionPath: "devices",
        filter: {
            field: "platform",
            op: "==",
            value: "ios",
        },
        queries: [platformQuery("ios")],
    },
    {
        key: "pro",
        label: "Premium",
        collectionPath: "users",
        filter: {
            field: "isPro",
            op: "==",
            value: true,
        },
        queries: [{
            path: "users",
            field: "isPro",
            op: "==",
            value: true,
        }],
    },
    {
        key: "feedbacks",
        label: "Geri bildirim",
        collectionPath: "feedbacks",
        queries: [{ path: "feedbacks" }],
    },
    {
        key: "trial_left",
        label: "Ücretsiz hakkı olan",
        collectionPath: "devices",
        filter: {
            field: "freeTrialLeft",
            op: ">",
            value: 0,
        },
        queries: [{
            path: "devices",
            field: "freeTrialLeft",
            op: ">",
            value: 0,
        }],
    },
];
